<ng-container *transloco="let t">
    <!-- Breadcrumb -->
    <div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
        <h5 class="mb-0">
            {{t('edit')}} {{t('company')}}
        </h5>
        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <li class="breadcrumb-item position-relative">
                {{t('Masters')}}
            </li>
            <li class="breadcrumb-item position-relative">
                <a routerLink="/masters/companies" class="d-inline-block position-relative">
                    {{t('Companies')}}
                </a>
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('edit')}} {{t('company')}}
            </li>
        </ol>
    </div>

    <!-- Edit Company -->
    <mat-card class="altair-card edit-company-card mb-25 border-radius bg-white border-none d-block"
        [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-content>
            <div *ngIf="editCompany">
                <form [formGroup]="editCompanyForm">
                    <div class="row">
                        <div class="col-md-4 col-sm-6">
                            <div class="mb-25">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('name')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('enter-name')}}
                                    </mat-label>
                                    <input matInput type="text" id="name" formControlName="name"
                                        [(ngModel)]="editCompany.name" required>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6">
                            <div class="mb-25">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('identificationType')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('select-identificationType')}}
                                    </mat-label>
                                    <mat-select name="identificationType" [(value)]="editCompany.identificationType"
                                        required>
                                        <mat-option *ngFor="let identificationType of identificationTypes"
                                            [value]="identificationType.short">
                                            {{identificationType.full}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6">
                            <div class="mb-25">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('identification')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('enter-identification')}}
                                    </mat-label>
                                    <input matInput type="text" id="identification" formControlName="identification"
                                        [(ngModel)]="editCompany.identification" required>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6">
                            <div class="mb-25">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('address')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('enter-address')}}
                                    </mat-label>
                                    <input matInput type="text" id="address" formControlName="address"
                                        [(ngModel)]="editCompany.address" required>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6">
                            <div class="mb-25">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('startContract')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('choose-a-date')}}
                                    </mat-label>
                                    <input matInput [matDatepicker]="startContract" formControlName="startContract"
                                        [(ngModel)]="editCompany.startContract" [max]="editCompany.endContract"
                                        required>
                                    <mat-hint>DD/MM/YYYY</mat-hint>
                                    <mat-datepicker-toggle matIconSuffix [for]="startContract"></mat-datepicker-toggle>
                                    <mat-datepicker #startContract disabled="false"></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6">
                            <div class="mb-25">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('contract-duration')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('enter-range-to-add')}}
                                    </mat-label>
                                    <input matInput type="number" name="amount" formControlName="amount"
                                        (keyup)="changeEndContract()">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6">
                            <div class="mb-25">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('contract-period')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('select-period')}}
                                    </mat-label>
                                    <mat-select name="period" [(value)]="selectedPeriod"
                                        (selectionChange)="changeEndContract()">
                                        <mat-option *ngFor="let type of periodTypes" [value]="type">
                                            {{t(type)}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6">
                            <div class="mb-25">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('endContract')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('choose-a-date')}}
                                    </mat-label>
                                    <input matInput [matDatepicker]="endContract" formControlName="endContract"
                                        [(ngModel)]="editCompany.endContract" required>
                                    <mat-hint>DD/MM/YYYY</mat-hint>
                                    <mat-datepicker-toggle matIconSuffix [for]="endContract"></mat-datepicker-toggle>
                                    <mat-datepicker #endContract disabled="true"></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="btn-box">
                        <button mat-flat-button class="altair" (click)="toggleClass()">
                            {{t('add')}} {{t('contact')}}
                        </button>
                        <button mat-flat-button color="warn" [disabled]="!contactInfos.length"
                            (click)="removeSelectedRows()">
                            {{t('remove')}} {{t('contacts')}}
                        </button>
                    </div>

                    <!-- Table -->
                    <div class="row">
                        <table mat-table [dataSource]="dataSource">
                            <!-- Checkbox Column -->
                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef>
                                    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                                        [checked]="selection.hasValue() && isAllSelected()"
                                        [indeterminate]="selection.hasValue() && !isAllSelected()">
                                    </mat-checkbox>
                                </th>
                                <td mat-cell *matCellDef="let row">
                                    <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="$event ? selection.toggle(row) : null"
                                        [checked]="selection.isSelected(row)">
                                    </mat-checkbox>
                                </td>
                            </ng-container>
                            <!-- Contact Medium Type Column -->
                            <ng-container matColumnDef="contactMediumName">
                                <th mat-header-cell *matHeaderCellDef>{{t('contact-medium-type')}}</th>
                                <td mat-cell *matCellDef="let element">{{element.contactMediumType.name}}</td>
                            </ng-container>
                            <!-- Contact Column -->
                            <ng-container matColumnDef="contact">
                                <th mat-header-cell *matHeaderCellDef>{{t('contact')}}</th>
                                <td mat-cell *matCellDef="let element">{{element.contact}}</td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                                (click)="selection.toggle(row)"></tr>
                        </table>
                    </div>

                    <div class="btn-box">
                        <button mat-button type="button" (click)="onSubmit()" [disabled]="editCompanyForm.invalid">
                            {{t('save')}} {{t('company')}}
                        </button>
                        <a mat-button routerLink="/masters/companies">
                            {{t('cancel')}}
                        </a>
                    </div>
                </form>
            </div>
        </mat-card-content>
    </mat-card>

    <!-- Popup -->
    <div class="add-new-contact-popup" [class.active]="classApplied" [class.rtl-enabled]="themeService.isRTLEnabled()">
        <div class="popup-dialog">
            <mat-card class="altair-card mb-25 border-radius bg-white border-none d-block">
                <mat-card-header>
                    <mat-card-title>
                        <h5 class="mt-0 mb-0">
                            {{t('add')}} {{t('contact')}}
                        </h5>
                    </mat-card-title>
                    <mat-card-subtitle>
                        <button mat-button (click)="toggleClass()">
                            <i class="ri-close-fill"></i>
                        </button>
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <form [formGroup]="editContactForm">
                        <div class="row">
                            <div class="col-md-12">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('contact-medium-type')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('select-contact-medium-type')}}
                                    </mat-label>
                                    <mat-select name="contactMediumType" [(value)]="selectedContactMediumType" required>
                                        <mat-option *ngFor="let contactMediumType of contactMediumTypes"
                                            [value]="contactMediumType">
                                            {{contactMediumType.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <label class="main-label d-block lh-1 text-black">
                                    {{t('contact')}}
                                </label>
                                <mat-form-field>
                                    <mat-label>
                                        {{t('enter-contact')}}
                                    </mat-label>
                                    <input matInput id="contact" formControlName="contact" required>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="btn-box">
                            <button mat-button (click)="toggleClass()">
                                {{t('cancel')}}
                            </button>
                            <button mat-button type="button" (click)="addContactInfo()"
                                [disabled]="editContactForm.invalid || selectedContactMediumType === undefined">
                                {{t('add')}} {{t('contact')}}
                            </button>
                        </div>
                    </form>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</ng-container>
